import { RouterProvider } from 'react-router-dom';
import { AppRouter } from './Routes';
import { ConfigProvider } from 'antd';

// Helper function to get CSS variables from :root
const getCSSVariable = (variable) => getComputedStyle(document.documentElement).getPropertyValue(variable).trim();


function App() {
  return (
    <>
        <ConfigProvider theme={{
          components: {
            Switch: {
              colorPrimary: getCSSVariable('--tenGreen'),
              colorTextQuaternary: getCSSVariable('--fourthRed'),
              colorPrimaryHover: getCSSVariable('--tenGreen'),
              colorTextTertiary: getCSSVariable('--fourthRed'),
            },
            Table: {
              headerBg: getCSSVariable('--fifthgray'), // Background color for table header
              headerColor: getCSSVariable(' --primaryblack'), // Text color for header
              rowBg: getCSSVariable('--primarywhite'), // Table row background
              rowHoverBg: 'none', // Table row hover color
              borderRadius: 0, // Remove table border radius
            },
          },
        }}>
          <RouterProvider router={AppRouter} />
        </ConfigProvider>
    </>
  );
}

export default App;
